// extracted by mini-css-extract-plugin
export default {"Container":"QuestionExpand_Container__buL6q","Question":"QuestionExpand_Question__2XE-V","Answer":"QuestionExpand_Answer__6I6Io"};